import React, { Component } from 'react';
import Responsive from "./Responsive/Prognos";
import Drawer from "./Drawer/index";

export default class DashboardPrognos extends Component {
    render() {
        return (
            <div>
                <div style={{ position: 'absolute', zIndex: 1, right: '-12px', top: '50%' }}>
                    <Drawer />
                </div>
                <div>
                    <Responsive />
                </div>
            </div>
        )
    }
}
